// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // import { API } from "../config";
// // import "../../style/RectorSimulacros.css";

// // export default function RectorSimulacros() {

// //   const token = localStorage.getItem("token");

// //   const headers = {
// //     Authorization: `Bearer ${token}`
// //   };

// //   /* =====================================================
// //      STATES
// //   ===================================================== */

// //   const [simulacros, setSimulacros] = useState([]);
// //   const [profesores, setProfesores] = useState([]);
// //   const [sedes, setSedes] = useState([]);
// //   const [materias, setMaterias] = useState([]);

// //   const [loading, setLoading] = useState(false);
// //   const [loadingMateria, setLoadingMateria] = useState(false);

// //   const [nuevaMateria, setNuevaMateria] = useState("");

// //   const [form, setForm] = useState({
// //     titulo: "",
// //     descripcion: "",
// //     sede_id: "",
// //     grado: "GENERAL",
// //     tiempo_minutos: 120,
// //     fecha_inicio: "",
// //     fecha_fin: ""
// //   });

// //   const [asignacion, setAsignacion] = useState({
// //     profesor_id: "",
// //     materia_simulacro_id: ""
// //   });

// //   /* =====================================================
// //      FETCH DATA
// //   ===================================================== */

// //   const fetchSimulacros = async () => {

// //     try {

// //       const res = await axios.get(
// //         `${API}/simulacros/rector/simulacros`,
// //         { headers }
// //       );

// //       setSimulacros(res.data.simulacros || []);

// //     } catch (err) {

// //       console.error(
// //         "❌ Error simulacros:",
// //         err.response?.data || err.message
// //       );
// //     }
// //   };

// //   const fetchProfesores = async () => {

// //     try {

// //       const res = await axios.get(
// //         `${API}/simulacros/users/profesores`,
// //         { headers }
// //       );

// //       setProfesores(res.data.users || []);

// //     } catch (err) {

// //       console.error(
// //         "❌ Error profesores:",
// //         err.response?.data || err.message
// //       );
// //     }
// //   };

// //   const fetchSedes = async () => {

// //     try {

// //       const res = await axios.get(
// //         `${API}/simulacros/sedes/list`,
// //         { headers }
// //       );

// //       setSedes(res.data.sedes || []);

// //     } catch (err) {

// //       console.error(
// //         "❌ Error sedes:",
// //         err.response?.data || err.message
// //       );
// //     }
// //   };

// //   const fetchMaterias = async () => {

// //     try {

// //       const res = await axios.get(
// //         `${API}/simulacros/materias`,
// //         { headers }
// //       );

// //       setMaterias(res.data.materias || []);

// //     } catch (err) {

// //       console.error(
// //         "❌ Error materias:",
// //         err.response?.data || err.message
// //       );
// //     }
// //   };

// //   useEffect(() => {

// //     fetchSimulacros();
// //     fetchProfesores();
// //     fetchSedes();
// //     fetchMaterias();

// //   }, []);

// //   /* =====================================================
// //      CREAR MATERIA
// //   ===================================================== */

// //   const crearMateria = async () => {

// //     try {

// //       if (!nuevaMateria.trim()) {
// //         return alert("Ingrese el nombre de la materia");
// //       }

// //       setLoadingMateria(true);

// //       const res = await axios.post(
// //         `${API}/simulacros/rector/materia`,
// //         {
// //           nombre: nuevaMateria.trim()
// //         },
// //         { headers }
// //       );

// //       console.log(
// //         "✅ Materia creada:",
// //         res.data
// //       );

// //       alert("Materia creada correctamente");

// //       setNuevaMateria("");

// //       fetchMaterias();

// //     } catch (err) {

// //       console.error(
// //         "❌ Error creando materia:",
// //         err.response?.data || err.message
// //       );

// //       alert(
// //         err.response?.data?.message ||
// //         "Error creando materia"
// //       );

// //     } finally {

// //       setLoadingMateria(false);
// //     }
// //   };

// //   /* =====================================================
// //      CREAR SIMULACRO
// //   ===================================================== */

// //   const crearSimulacro = async () => {

// //     try {

// //       if (!form.titulo.trim()) {
// //         return alert("El título es obligatorio");
// //       }

// //       if (!form.sede_id) {
// //         return alert("Debe seleccionar una sede");
// //       }

// //       setLoading(true);

// //       const payload = {
// //         titulo: form.titulo.trim(),
// //         descripcion: form.descripcion.trim(),
// //         sede_id: Number(form.sede_id),
// //         grado: form.grado,
// //         tiempo_minutos: Number(form.tiempo_minutos),
// //         fecha_inicio: form.fecha_inicio || null,
// //         fecha_fin: form.fecha_fin || null
// //       };

// //       const res = await axios.post(
// //         `${API}/simulacros/rector/simulacro`,
// //         payload,
// //         { headers }
// //       );

// //       console.log(
// //         "✅ Simulacro creado:",
// //         res.data
// //       );

// //       alert("Simulacro creado correctamente");

// //       setForm({
// //         titulo: "",
// //         descripcion: "",
// //         sede_id: "",
// //         grado: "GENERAL",
// //         tiempo_minutos: 120,
// //         fecha_inicio: "",
// //         fecha_fin: ""
// //       });

// //       fetchSimulacros();

// //     } catch (err) {

// //       console.error(
// //         "❌ Error creando simulacro:",
// //         err.response?.data || err.message
// //       );

// //       alert(
// //         err.response?.data?.message ||
// //         "Error creando simulacro"
// //       );

// //     } finally {

// //       setLoading(false);
// //     }
// //   };

// //   /* =====================================================
// //      ASIGNAR PROFESOR + MATERIA
// //   ===================================================== */

// //   const asignar = async (simulacro_id) => {

// //     try {

// //       if (!asignacion.profesor_id) {
// //         return alert("Debe seleccionar un profesor");
// //       }

// //       if (!asignacion.materia_simulacro_id) {
// //         return alert("Debe seleccionar una materia");
// //       }

// //       const payload = {
// //         simulacro_id: Number(simulacro_id),
// //         profesor_id: Number(asignacion.profesor_id),
// //         materia_simulacro_id: Number(
// //           asignacion.materia_simulacro_id
// //         )
// //       };

// //       console.log("📤 Payload:", payload);

// //       const res = await axios.post(
// //         `${API}/simulacros/rector/simulacro/profesor-materia`,
// //         payload,
// //         { headers }
// //       );

// //       console.log(
// //         "✅ Profesor asignado:",
// //         res.data
// //       );

// //       alert("Profesor asignado correctamente");

// //     } catch (err) {

// //       console.error(
// //         "❌ Error asignando:",
// //         err.response?.data || err.message
// //       );

// //       alert(
// //         err.response?.data?.message ||
// //         "Error asignando profesor"
// //       );
// //     }
// //   };

// //   /* =====================================================
// //      RENDER
// //   ===================================================== */

// //   return (
// //     <div className="simulacros-container">

// //       {/* ================================================= */}
// //       {/* HEADER */}
// //       {/* ================================================= */}

// //       <div className="page-header">

// //         <h2 className="title">
// //           🟣 Rector - Simulacros ICFES
// //         </h2>

// //         <p className="subtitle">
// //           Gestión institucional de simulacros
// //         </p>

// //       </div>

// //       {/* ================================================= */}
// //       {/* CREAR MATERIAS */}
// //       {/* ================================================= */}

// //       <div className="card">

// //         <h3 className="section-title">
// //           📚 Materias globales del simulacro
// //         </h3>

// //         <div className="form-grid">

// //           <div className="form-group">

// //             <label>Nombre de la materia</label>

// //             <input
// //               type="text"
// //               placeholder="Ej: Matemáticas"
// //               value={nuevaMateria}
// //               onChange={(e) =>
// //                 setNuevaMateria(e.target.value)
// //               }
// //             />

// //           </div>

// //         </div>

// //         <button
// //           className="primary-btn"
// //           disabled={loadingMateria}
// //           onClick={crearMateria}
// //         >
// //           {
// //             loadingMateria
// //               ? "Guardando..."
// //               : "Agregar materia"
// //           }
// //         </button>

// //         <div className="materias-list">

// //           {
// //             materias.map((m) => (

// //               <div
// //                 key={m.id}
// //                 className="materia-item"
// //               >
// //                 📘 {m.nombre}
// //               </div>
// //             ))
// //           }

// //         </div>

// //       </div>

// //       {/* ================================================= */}
// //       {/* CREAR SIMULACRO */}
// //       {/* ================================================= */}

// //       <div className="card">

// //         <h3 className="section-title">
// //           Crear simulacro
// //         </h3>

// //         <div className="form-grid">

// //           {/* TITULO */}
// //           <div className="form-group">

// //             <label>Título</label>

// //             <input
// //               type="text"
// //               placeholder="Ej: Simulacro Saber 11"
// //               value={form.titulo}
// //               onChange={(e) =>
// //                 setForm({
// //                   ...form,
// //                   titulo: e.target.value
// //                 })
// //               }
// //             />

// //           </div>

// //           {/* DESCRIPCION */}
// //           <div className="form-group">

// //             <label>Descripción</label>

// //             <input
// //               type="text"
// //               placeholder="Descripción"
// //               value={form.descripcion}
// //               onChange={(e) =>
// //                 setForm({
// //                   ...form,
// //                   descripcion: e.target.value
// //                 })
// //               }
// //             />

// //           </div>

// //           {/* SEDE */}
// //           <div className="form-group">

// //             <label>Sede</label>

// //             <select
// //               value={form.sede_id}
// //               onChange={(e) =>
// //                 setForm({
// //                   ...form,
// //                   sede_id: e.target.value
// //                 })
// //               }
// //             >
// //               <option value="">
// //                 Seleccionar sede
// //               </option>

// //               {
// //                 sedes.map((s) => (
// //                   <option
// //                     key={s.id}
// //                     value={s.id}
// //                   >
// //                     {s.nombre}
// //                   </option>
// //                 ))
// //               }

// //             </select>

// //           </div>

// //           {/* GRADO */}
// //           <div className="form-group">

// //             <label>Grado</label>

// //             <select
// //               value={form.grado}
// //               onChange={(e) =>
// //                 setForm({
// //                   ...form,
// //                   grado: e.target.value
// //                 })
// //               }
// //             >
// //               <option value="GENERAL">
// //                 GENERAL
// //               </option>

// //               <option value="11A">
// //                 11-A
// //               </option>

// //               <option value="11B">
// //                 11-B
// //               </option>

// //             </select>

// //           </div>

// //           {/* TIEMPO */}
// //           <div className="form-group">

// //             <label>Tiempo (minutos)</label>

// //             <input
// //               type="number"
// //               min="1"
// //               value={form.tiempo_minutos}
// //               onChange={(e) =>
// //                 setForm({
// //                   ...form,
// //                   tiempo_minutos: e.target.value
// //                 })
// //               }
// //             />

// //           </div>

// //           {/* FECHA INICIO */}
// //           <div className="form-group">

// //             <label>Fecha inicio</label>

// //             <input
// //               type="date"
// //               value={form.fecha_inicio}
// //               onChange={(e) =>
// //                 setForm({
// //                   ...form,
// //                   fecha_inicio: e.target.value
// //                 })
// //               }
// //             />

// //           </div>

// //           {/* FECHA FIN */}
// //           <div className="form-group">

// //             <label>Fecha fin</label>

// //             <input
// //               type="date"
// //               value={form.fecha_fin}
// //               onChange={(e) =>
// //                 setForm({
// //                   ...form,
// //                   fecha_fin: e.target.value
// //                 })
// //               }
// //             />

// //           </div>

// //         </div>

// //         <button
// //           className="primary-btn"
// //           disabled={loading}
// //           onClick={crearSimulacro}
// //         >
// //           {
// //             loading
// //               ? "Creando..."
// //               : "Crear simulacro"
// //           }
// //         </button>

// //       </div>

// //       {/* ================================================= */}
// //       {/* ASIGNACIÓN */}
// //       {/* ================================================= */}

// //       <div className="card">

// //         <h3 className="section-title">
// //           Asignar profesor y materia
// //         </h3>

// //         <div className="form-grid">

// //           {/* PROFESOR */}
// //           <div className="form-group">

// //             <label>Profesor</label>

// //             <select
// //               value={asignacion.profesor_id}
// //               onChange={(e) =>
// //                 setAsignacion({
// //                   ...asignacion,
// //                   profesor_id: e.target.value
// //                 })
// //               }
// //             >
// //               <option value="">
// //                 Seleccionar profesor
// //               </option>

// //               {
// //                 profesores.map((p) => (
// //                   <option
// //                     key={p.id}
// //                     value={p.id}
// //                   >
// //                     {p.nombre} {p.apellido}
// //                   </option>
// //                 ))
// //               }

// //             </select>

// //           </div>

// //           {/* MATERIA */}
// //           <div className="form-group">

// //             <label>Materia</label>

// //             <select
// //               value={asignacion.materia_simulacro_id}
// //               onChange={(e) =>
// //                 setAsignacion({
// //                   ...asignacion,
// //                   materia_simulacro_id: e.target.value
// //                 })
// //               }
// //             >
// //               <option value="">
// //                 Seleccionar materia
// //               </option>

// //               {
// //                 materias.map((m) => (
// //                   <option
// //                     key={m.id}
// //                     value={m.id}
// //                   >
// //                     {m.nombre}
// //                   </option>
// //                 ))
// //               }

// //             </select>

// //           </div>

// //         </div>

// //       </div>

// //       {/* ================================================= */}
// //       {/* LISTA */}
// //       {/* ================================================= */}

// //       <div className="simulacros-list">

// //         <h3 className="section-title">
// //           Simulacros creados
// //         </h3>

// //         {
// //           simulacros.length === 0 && (
// //             <div className="empty-state">
// //               No hay simulacros creados
// //             </div>
// //           )
// //         }

// //         {
// //           simulacros.map((s) => (

// //             <div
// //               key={s.id}
// //               className="simulacro-card"
// //             >

// //               <div className="simulacro-top">

// //                 <h4>
// //                   📘 {s.titulo}
// //                 </h4>

// //               </div>

// //               <p className="descripcion">
// //                 {
// //                   s.descripcion ||
// //                   "Sin descripción"
// //                 }
// //               </p>

// //               <div className="simulacro-info">

// //                 <span>
// //                   🎓 {s.grado}
// //                 </span>

// //                 <span>
// //                   🏫 {s.sede_nombre || s.sede_id}
// //                 </span>

// //                 <span>
// //                   ⏱️ {s.tiempo_minutos} min
// //                 </span>

// //               </div>

// //               <div className="simulacro-fechas">

// //                 {
// //                   s.fecha_inicio && (
// //                     <span>
// //                       📅 Inicio: {s.fecha_inicio}
// //                     </span>
// //                   )
// //                 }

// //                 {
// //                   s.fecha_fin && (
// //                     <span>
// //                       🛑 Fin: {s.fecha_fin}
// //                     </span>
// //                   )
// //                 }

// //               </div>

// //               <button
// //                 className="assign-btn"
// //                 onClick={() => asignar(s.id)}
// //               >
// //                 Asignar profesor
// //               </button>

// //             </div>
// //           ))
// //         }

// //       </div>

// //     </div>
// //   );
// // }
 


// import React, {
//   useEffect,
//   useState
// } from "react";

// import axios from "axios";

// import { API } from "../config";

// import "../../style/RectorSimulacros.css";

// export default function RectorSimulacros() {

//   const token =
//     localStorage.getItem("token");

//   const headers = {
//     Authorization: `Bearer ${token}`
//   };

//   /* =====================================================
//      STATES
//   ===================================================== */

//   const [simulacros, setSimulacros] =
//     useState([]);

//   const [profesores, setProfesores] =
//     useState([]);

//   const [materias, setMaterias] =
//     useState([]);

//   const [grados, setGrados] =
//     useState([]);

//   const [resumenes, setResumenes] =
//     useState({});

//   const [loading, setLoading] =
//     useState(false);

//   const [loadingMateria, setLoadingMateria] =
//     useState(false);

//   const [publicandoId, setPublicandoId] =
//     useState(null);

//   const [nuevaMateria, setNuevaMateria] =
//     useState("");

//   const [form, setForm] = useState({
//     titulo: "",
//     descripcion: "",
//     tiempo_minutos: 120,

//     // GENERAL = todos los 11
//     grupoSeleccionado: "GENERAL"
//   });

//   const [asignacion, setAsignacion] =
//     useState({
//       profesor_id: "",
//       materia_simulacro_id: ""
//     });

//   /* =====================================================
//      FETCH SIMULACROS
//   ===================================================== */

//   const fetchSimulacros = async () => {

//     try {

//       const res = await axios.get(
//         `${API}/simulacros/rector/simulacros`,
//         { headers }
//       );

//       const lista =
//         res.data.simulacros || [];

//       setSimulacros(lista);

//       /* =========================================
//          CARGAR RESUMENES
//       ========================================= */

//       for (const sim of lista) {

//         fetchResumen(sim.id);
//       }

//     } catch (err) {

//       console.error(
//         "❌ Error simulacros:",
//         err.response?.data || err.message
//       );
//     }
//   };

//   /* =====================================================
//      FETCH RESUMEN
//   ===================================================== */

//   const fetchResumen = async (
//     simulacro_id
//   ) => {

//     try {

//       const res = await axios.get(
//         `${API}/simulacros/rector/resumen/${simulacro_id}`,
//         { headers }
//       );

//       setResumenes(prev => ({
//         ...prev,
//         [simulacro_id]: res.data
//       }));

//     } catch (err) {

//       console.error(
//         "❌ Error resumen:",
//         simulacro_id,
//         err.response?.data || err.message
//       );
//     }
//   };

//   /* =====================================================
//      FETCH PROFESORES
//   ===================================================== */

//   const fetchProfesores = async () => {

//     try {

//       const res = await axios.get(
//         `${API}/simulacros/users/profesores`,
//         { headers }
//       );

//       setProfesores(
//         res.data.users || []
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error profesores:",
//         err.response?.data || err.message
//       );
//     }
//   };

//   /* =====================================================
//      FETCH MATERIAS
//   ===================================================== */

//   const fetchMaterias = async () => {

//     try {

//       const res = await axios.get(
//         `${API}/simulacros/materias`,
//         { headers }
//       );

//       setMaterias(
//         res.data.materias || []
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error materias:",
//         err.response?.data || err.message
//       );
//     }
//   };

//   /* =====================================================
//      FETCH GRADOS 11
//   ===================================================== */

//   const fetchGrados = async () => {

//     try {

//       const res = await axios.get(
//         `${API}/simulacros/rector/grados-once`,
//         { headers }
//       );

//       setGrados(
//         res.data.grados || []
//       );

//     } catch (err) {

//       console.error(
//         "❌ Error grados:",
//         err.response?.data || err.message
//       );
//     }
//   };

//   /* =====================================================
//      INIT
//   ===================================================== */

//   useEffect(() => {

//     fetchSimulacros();
//     fetchProfesores();
//     fetchMaterias();
//     fetchGrados();

//   }, []);

//   /* =====================================================
//      CREAR MATERIA
//   ===================================================== */

//   const crearMateria = async () => {

//     try {

//       if (!nuevaMateria.trim()) {

//         return alert(
//           "Ingrese nombre"
//         );
//       }

//       setLoadingMateria(true);

//       await axios.post(
//         `${API}/simulacros/rector/materia`,
//         {
//           nombre:
//             nuevaMateria.trim()
//         },
//         { headers }
//       );

//       alert(
//         "Materia creada"
//       );

//       setNuevaMateria("");

//       fetchMaterias();

//     } catch (err) {

//       console.error(err);

//       alert(
//         err.response?.data?.message ||
//         "Error"
//       );

//     } finally {

//       setLoadingMateria(false);
//     }
//   };

//   /* =====================================================
//      CREAR SIMULACRO
//   ===================================================== */

//   const crearSimulacro = async () => {

//     try {

//       if (!form.titulo.trim()) {

//         return alert(
//           "Título obligatorio"
//         );
//       }

//       setLoading(true);

//       let payload = {
//         titulo:
//           form.titulo.trim(),

//         descripcion:
//           form.descripcion.trim(),

//         tiempo_minutos:
//           Number(
//             form.tiempo_minutos
//           ),

//         grado: "11",

//         grupo: "GENERAL",

//         sede_id: null
//       };

//       /* =========================================
//          SI ES ESPECIFICO
//       ========================================= */

//       if (
//         form.grupoSeleccionado !==
//         "GENERAL"
//       ) {

//         const seleccionado =
//           JSON.parse(
//             form.grupoSeleccionado
//           );

//         payload = {
//           ...payload,

//           grado:
//             seleccionado.grado,

//           grupo:
//             seleccionado.grupo,

//           sede_id:
//             seleccionado.sede_id
//         };
//       }

//       console.log(
//         "📤 Payload simulacro:",
//         payload
//       );

//       await axios.post(
//         `${API}/simulacros/rector/simulacro`,
//         payload,
//         { headers }
//       );

//       alert(
//         "Simulacro creado"
//       );

//       setForm({
//         titulo: "",
//         descripcion: "",
//         tiempo_minutos: 120,
//         grupoSeleccionado:
//           "GENERAL"
//       });

//       fetchSimulacros();

//     } catch (err) {

//       console.error(err);

//       alert(
//         err.response?.data?.message ||
//         "Error creando simulacro"
//       );

//     } finally {

//       setLoading(false);
//     }
//   };

//   /* =====================================================
//      PUBLICAR SIMULACRO
//   ===================================================== */

//   const publicarSimulacro = async (
//     simulacro_id
//   ) => {

//     try {

//       const confirmar =
//         window.confirm(
//           "¿Desea publicar este simulacro para los estudiantes?"
//         );

//       if (!confirmar) {
//         return;
//       }

//       setPublicandoId(
//         simulacro_id
//       );

//       const res = await axios.put(
//         `${API}/simulacros/rector/publicar/${simulacro_id}`,
//         {},
//         { headers }
//       );

//       alert(
//         res.data.message ||
//         "Simulacro publicado"
//       );

//       fetchSimulacros();

//     } catch (err) {

//       console.error(
//         "❌ Error publicando:",
//         err.response?.data || err.message
//       );

//       alert(
//         err.response?.data?.message ||
//         "Error publicando simulacro"
//       );

//     } finally {

//       setPublicandoId(null);
//     }
//   };

//   /* =====================================================
//      ASIGNAR
//   ===================================================== */

//   const asignar = async (
//     simulacro_id
//   ) => {

//     try {

//       if (!asignacion.profesor_id) {

//         return alert(
//           "Seleccione profesor"
//         );
//       }

//       if (
//         !asignacion.materia_simulacro_id
//       ) {

//         return alert(
//           "Seleccione materia"
//         );
//       }

//       await axios.post(
//         `${API}/simulacros/rector/simulacro/profesor-materia`,
//         {
//           simulacro_id,

//           profesor_id:
//             Number(
//               asignacion.profesor_id
//             ),

//           materia_simulacro_id:
//             Number(
//               asignacion.materia_simulacro_id
//             )
//         },
//         { headers }
//       );

//       alert(
//         "Profesor asignado"
//       );

//       fetchResumen(simulacro_id);

//     } catch (err) {

//       console.error(err);

//       alert(
//         err.response?.data?.message ||
//         "Error asignando"
//       );
//     }
//   };

//   /* =====================================================
//      RENDER
//   ===================================================== */

//   return (

//     <div className="simulacros-container">

//       <h2>
//         🟣 Rector - Simulacros
//       </h2>

//       {/* ================================================= */}
//       {/* CREAR MATERIA */}
//       {/* ================================================= */}

//       <div className="card">

//         <h3>
//           📚 Materias
//         </h3>

//         <input
//           type="text"
//           placeholder="Nueva materia"
//           value={nuevaMateria}
//           onChange={(e) =>
//             setNuevaMateria(
//               e.target.value
//             )
//           }
//         />

//         <button
//           onClick={crearMateria}
//         >
//           {
//             loadingMateria
//               ? "Guardando..."
//               : "Crear materia"
//           }
//         </button>

//       </div>

//       {/* ================================================= */}
//       {/* CREAR SIMULACRO */}
//       {/* ================================================= */}

//       <div className="card">

//         <h3>
//           📝 Crear simulacro
//         </h3>

//         <input
//           type="text"
//           placeholder="Título"
//           value={form.titulo}
//           onChange={(e) =>
//             setForm({
//               ...form,
//               titulo:
//                 e.target.value
//             })
//           }
//         />

//         <textarea
//           placeholder="Descripción"
//           value={form.descripcion}
//           onChange={(e) =>
//             setForm({
//               ...form,
//               descripcion:
//                 e.target.value
//             })
//           }
//         />

//         {/* ========================================= */}
//         {/* GRUPOS */}
//         {/* ========================================= */}

//         <select
//           value={
//             form.grupoSeleccionado
//           }
//           onChange={(e) =>
//             setForm({
//               ...form,
//               grupoSeleccionado:
//                 e.target.value
//             })
//           }
//         >

//           <option value="GENERAL">
//             TODOS LOS 11
//           </option>

//           {
//             grados.map((g, index) => (

//               <option
//                 key={index}
//                 value={JSON.stringify({
//                   grado: g.grado,
//                   grupo: g.grupo,
//                   sede_id: g.sede_id
//                 })}
//               >
//                 {g.sede}
//                 {" - "}
//                 {g.grado}
//                 {" "}
//                 {g.grupo}
//               </option>
//             ))
//           }

//         </select>

//         <input
//           type="number"
//           placeholder="Tiempo"
//           value={
//             form.tiempo_minutos
//           }
//           onChange={(e) =>
//             setForm({
//               ...form,
//               tiempo_minutos:
//                 e.target.value
//             })
//           }
//         />

//         <button
//           onClick={
//             crearSimulacro
//           }
//         >
//           {
//             loading
//               ? "Creando..."
//               : "Crear simulacro"
//           }
//         </button>

//       </div>

//       {/* ================================================= */}
//       {/* ASIGNACIÓN */}
//       {/* ================================================= */}

//       <div className="card">

//         <h3>
//           👨‍🏫 Asignar profesor
//         </h3>

//         <select
//           value={
//             asignacion.profesor_id
//           }
//           onChange={(e) =>
//             setAsignacion({
//               ...asignacion,
//               profesor_id:
//                 e.target.value
//             })
//           }
//         >

//           <option value="">
//             Profesor
//           </option>

//           {
//             profesores.map((p) => (

//               <option
//                 key={p.id}
//                 value={p.id}
//               >
//                 {p.nombre}
//                 {" "}
//                 {p.apellido}
//               </option>
//             ))
//           }

//         </select>

//         <select
//           value={
//             asignacion.materia_simulacro_id
//           }
//           onChange={(e) =>
//             setAsignacion({
//               ...asignacion,
//               materia_simulacro_id:
//                 e.target.value
//             })
//           }
//         >

//           <option value="">
//             Materia
//           </option>

//           {
//             materias.map((m) => (

//               <option
//                 key={m.id}
//                 value={m.id}
//               >
//                 {m.nombre}
//               </option>
//             ))
//           }

//         </select>

//       </div>

//       {/* ================================================= */}
//       {/* LISTA */}
//       {/* ================================================= */}

//       {
//         simulacros.map((s) => {

//           const resumen =
//             resumenes[s.id];

//           const estadisticas =
//             resumen?.estadisticas;

//           const profes =
//             resumen?.profesores || [];

//           return (

//             <div
//               key={s.id}
//               className="simulacro-card"
//             >

//               <h3>
//                 📘 {s.titulo}
//               </h3>

//               <p>
//                 {
//                   s.descripcion
//                 }
//               </p>

//               {/* ===================================== */}
//               {/* ESTADO */}
//               {/* ===================================== */}

//               <div
//                 className="estado-box"
//                 style={{
//                   marginBottom: "10px"
//                 }}
//               >

//                 {
//                   s.estado ===
//                   "publicado"
//                     ? (
//                       <span
//                         style={{
//                           color: "green",
//                           fontWeight: "bold"
//                         }}
//                       >
//                         🟢 PUBLICADO
//                       </span>
//                     )
//                     : (
//                       <span
//                         style={{
//                           color: "orange",
//                           fontWeight: "bold"
//                         }}
//                       >
//                         🟡 BORRADOR
//                       </span>
//                     )
//                 }

//               </div>

//               {/* ===================================== */}
//               {/* DESTINO */}
//               {/* ===================================== */}

//               <div
//                 className="simulacro-destino"
//               >

//                 {
//                   s.grupo ===
//                   "GENERAL"
//                     ? (
//                       <span>
//                         🎯 TODOS LOS 11
//                       </span>
//                     )
//                     : (
//                       <span>
//                         🎯
//                         {" "}
//                         {s.grado}
//                         {" "}
//                         {s.grupo}
//                       </span>
//                     )
//                 }

//               </div>

//               {/* ===================================== */}
//               {/* ESTADISTICAS */}
//               {/* ===================================== */}

//               {
//                 estadisticas && (

//                   <div
//                     className="stats-box"
//                   >

//                     <div>
//                       👨‍🏫 Profesores:
//                       {" "}
//                       {
//                         estadisticas.total_profesores
//                       }
//                     </div>

//                     <div>
//                       ✅ Terminados:
//                       {" "}
//                       {
//                         estadisticas.terminados
//                       }
//                     </div>

//                     <div>
//                       ⏳ Pendientes:
//                       {" "}
//                       {
//                         estadisticas.pendientes
//                       }
//                     </div>

//                     <div>
//                       ❓ Preguntas:
//                       {" "}
//                       {
//                         estadisticas.total_preguntas
//                       }
//                     </div>

//                     <div>
//                       📊 Completado:
//                       {" "}
//                       {
//                         estadisticas.porcentaje_completado
//                       }%
//                     </div>

//                   </div>
//                 )
//               }

//               {/* ===================================== */}
//               {/* BOTONES */}
//               {/* ===================================== */}

//               <div
//                 style={{
//                   display: "flex",
//                   gap: "10px",
//                   flexWrap: "wrap",
//                   marginTop: "15px"
//                 }}
//               >

//                 <button
//                   onClick={() =>
//                     asignar(s.id)
//                   }
//                 >
//                   Asignar profesor
//                 </button>

//                 {
//                   s.estado !==
//                   "publicado" && (
//                     <button
//                       onClick={() =>
//                         publicarSimulacro(
//                           s.id
//                         )
//                       }
//                       disabled={
//                         publicandoId ===
//                         s.id
//                       }
//                       style={{
//                         background:
//                           "#198754",
//                         color: "#fff"
//                       }}
//                     >
//                       {
//                         publicandoId ===
//                         s.id
//                           ? "Publicando..."
//                           : "🚀 Publicar simulacro"
//                       }
//                     </button>
//                   )
//                 }

//               </div>

//               {/* ===================================== */}
//               {/* LISTA PROFESORES */}
//               {/* ===================================== */}

//               <div
//                 className="profesores-box"
//               >

//                 {
//                   profes.map((p) => (

//                     <div
//                       key={p.id}
//                       className="profesor-item"
//                     >

//                       <div>
//                         👨‍🏫
//                         {" "}
//                         {p.nombre}
//                         {" "}
//                         {p.apellido}
//                       </div>

//                       <div>
//                         📚
//                         {" "}
//                         {p.materia}
//                       </div>

//                       <div>
//                         ❓
//                         {" "}
//                         {
//                           p.total_preguntas
//                         }
//                         {" "}
//                         preguntas
//                       </div>

//                       <div>

//                         {
//                           p.estado ===
//                           "terminado"
//                             ? (
//                               <span
//                                 style={{
//                                   color:
//                                     "green",
//                                   fontWeight:
//                                     "bold"
//                                 }}
//                               >
//                                 ✅ TERMINADO
//                               </span>
//                             )
//                             : (
//                               <span
//                                 style={{
//                                   color:
//                                     "orange",
//                                   fontWeight:
//                                     "bold"
//                                 }}
//                               >
//                                 ⏳ PENDIENTE
//                               </span>
//                             )
//                         }

//                       </div>

//                     </div>
//                   ))
//                 }

//               </div>

//             </div>
//           );
//         })
//       }

//     </div>
//   );
// }

//
import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import { API } from "../config";

import "../../style/RectorSimulacros.css";

export default function RectorSimulacros() {

  const token =
    localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`
  };

  /* =====================================================
     STATES
  ===================================================== */

  const [simulacros, setSimulacros] =
    useState([]);

  const [profesores, setProfesores] =
    useState([]);

  const [materias, setMaterias] =
    useState([]);

  const [grados, setGrados] =
    useState([]);

  const [resumenes, setResumenes] =
    useState({});

  const [analiticas, setAnaliticas] =
    useState({});

  const [loading, setLoading] =
    useState(false);

  const [loadingMateria, setLoadingMateria] =
    useState(false);

  const [publicandoId, setPublicandoId] =
    useState(null);

  const [nuevaMateria, setNuevaMateria] =
    useState("");

  const [form, setForm] = useState({
    titulo: "",
    descripcion: "",
    tiempo_minutos: 120,
    grupoSeleccionado: "GENERAL"
  });

  const [asignacion, setAsignacion] =
    useState({
      profesor_id: "",
      materia_simulacro_id: ""
    });

  /* =====================================================
     FETCH SIMULACROS
  ===================================================== */

  const fetchSimulacros = async () => {

    try {

      const res = await axios.get(
        `${API}/simulacros/rector/simulacros`,
        { headers }
      );

      const lista =
        res.data.simulacros || [];

      setSimulacros(lista);

      for (const sim of lista) {

        fetchResumen(sim.id);

        fetchAnalitica(sim.id);
      }

    } catch (err) {

      console.error(
        "❌ Error simulacros:",
        err.response?.data || err.message
      );
    }
  };

  /* =====================================================
     FETCH RESUMEN
  ===================================================== */

  const fetchResumen = async (
    simulacro_id
  ) => {

    try {

      const res = await axios.get(
        `${API}/simulacros/rector/resumen/${simulacro_id}`,
        { headers }
      );

      setResumenes(prev => ({
        ...prev,
        [simulacro_id]: res.data
      }));

    } catch (err) {

      console.error(
        "❌ Error resumen:",
        simulacro_id,
        err.response?.data || err.message
      );
    }
  };

  /* =====================================================
     FETCH ANALITICA
  ===================================================== */

  const fetchAnalitica = async (
    simulacro_id
  ) => {

    try {

      const res = await axios.get(
        `${API}/simulacros/rector/analitica/${simulacro_id}`,
        { headers }
      );

      setAnaliticas(prev => ({
        ...prev,
        [simulacro_id]: res.data
      }));

    } catch (err) {

      console.error(
        "❌ Error analítica:",
        simulacro_id,
        err.response?.data || err.message
      );
    }
  };

  /* =====================================================
     FETCH PROFESORES
  ===================================================== */

  const fetchProfesores = async () => {

    try {

      const res = await axios.get(
        `${API}/simulacros/users/profesores`,
        { headers }
      );

      setProfesores(
        res.data.users || []
      );

    } catch (err) {

      console.error(
        "❌ Error profesores:",
        err.response?.data || err.message
      );
    }
  };

  /* =====================================================
     FETCH MATERIAS
  ===================================================== */

  const fetchMaterias = async () => {

    try {

      const res = await axios.get(
        `${API}/simulacros/materias`,
        { headers }
      );

      setMaterias(
        res.data.materias || []
      );

    } catch (err) {

      console.error(
        "❌ Error materias:",
        err.response?.data || err.message
      );
    }
  };

  /* =====================================================
     FETCH GRADOS
  ===================================================== */

  const fetchGrados = async () => {

    try {

      const res = await axios.get(
        `${API}/simulacros/rector/grados-once`,
        { headers }
      );

      setGrados(
        res.data.grados || []
      );

    } catch (err) {

      console.error(
        "❌ Error grados:",
        err.response?.data || err.message
      );
    }
  };

  /* =====================================================
     INIT
  ===================================================== */

  useEffect(() => {

    fetchSimulacros();
    fetchProfesores();
    fetchMaterias();
    fetchGrados();

  }, []);

  /* =====================================================
     CREAR MATERIA
  ===================================================== */

  const crearMateria = async () => {

    try {

      if (!nuevaMateria.trim()) {

        return alert(
          "Ingrese nombre"
        );
      }

      setLoadingMateria(true);

      await axios.post(
        `${API}/simulacros/rector/materia`,
        {
          nombre:
            nuevaMateria.trim()
        },
        { headers }
      );

      alert(
        "Materia creada"
      );

      setNuevaMateria("");

      fetchMaterias();

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.message ||
        "Error creando materia"
      );

    } finally {

      setLoadingMateria(false);
    }
  };

  /* =====================================================
     CREAR SIMULACRO
  ===================================================== */

  const crearSimulacro = async () => {

    try {

      if (!form.titulo.trim()) {

        return alert(
          "Título obligatorio"
        );
      }

      setLoading(true);

      let payload = {

        titulo:
          form.titulo.trim(),

        descripcion:
          form.descripcion.trim(),

        tiempo_minutos:
          Number(
            form.tiempo_minutos
          ),

        grado: "11",

        grupo: "GENERAL",

        sede_id: null
      };

      if (
        form.grupoSeleccionado !==
        "GENERAL"
      ) {

        const seleccionado =
          JSON.parse(
            form.grupoSeleccionado
          );

        payload = {

          ...payload,

          grado:
            seleccionado.grado,

          grupo:
            seleccionado.grupo,

          sede_id:
            seleccionado.sede_id
        };
      }

      await axios.post(
        `${API}/simulacros/rector/simulacro`,
        payload,
        { headers }
      );

      alert(
        "Simulacro creado"
      );

      setForm({
        titulo: "",
        descripcion: "",
        tiempo_minutos: 120,
        grupoSeleccionado: "GENERAL"
      });

      fetchSimulacros();

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.message ||
        "Error creando simulacro"
      );

    } finally {

      setLoading(false);
    }
  };

  /* =====================================================
     PUBLICAR
  ===================================================== */

  const publicarSimulacro = async (
    simulacro_id
  ) => {

    try {

      const confirmar =
        window.confirm(
          "¿Desea publicar este simulacro?"
        );

      if (!confirmar) {
        return;
      }

      setPublicandoId(
        simulacro_id
      );

      const res = await axios.put(
        `${API}/simulacros/rector/publicar/${simulacro_id}`,
        {},
        { headers }
      );

      alert(
        res.data.message ||
        "Simulacro publicado"
      );

      fetchSimulacros();

    } catch (err) {

      console.error(
        "❌ Error publicando:",
        err.response?.data || err.message
      );

      alert(
        err.response?.data?.message ||
        "Error publicando"
      );

    } finally {

      setPublicandoId(null);
    }
  };

  /* =====================================================
     ASIGNAR
  ===================================================== */

  const asignar = async (
    simulacro_id
  ) => {

    try {

      if (!asignacion.profesor_id) {

        return alert(
          "Seleccione profesor"
        );
      }

      if (
        !asignacion.materia_simulacro_id
      ) {

        return alert(
          "Seleccione materia"
        );
      }

      await axios.post(
        `${API}/simulacros/rector/simulacro/profesor-materia`,
        {
          simulacro_id,

          profesor_id:
            Number(
              asignacion.profesor_id
            ),

          materia_simulacro_id:
            Number(
              asignacion.materia_simulacro_id
            )
        },
        { headers }
      );

      alert(
        "Profesor asignado"
      );

      fetchResumen(simulacro_id);

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.message ||
        "Error asignando"
      );
    }
  };

  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div className="simulacros-container">

      <h2>
        🟣 Rector - Simulacros
      </h2>

      {/* ================================================= */}
      {/* MATERIAS */}
      {/* ================================================= */}

      <div className="card">

        <h3>
          📚 Materias
        </h3>

        <input
          type="text"
          placeholder="Nueva materia"
          value={nuevaMateria}
          onChange={(e) =>
            setNuevaMateria(
              e.target.value
            )
          }
        />

        <button
          onClick={crearMateria}
        >
          {
            loadingMateria
              ? "Guardando..."
              : "Crear materia"
          }
        </button>

      </div>

      {/* ================================================= */}
      {/* CREAR */}
      {/* ================================================= */}

      <div className="card">

        <h3>
          📝 Crear simulacro
        </h3>

        <input
          type="text"
          placeholder="Título"
          value={form.titulo}
          onChange={(e) =>
            setForm({
              ...form,
              titulo:
                e.target.value
            })
          }
        />

        <textarea
          placeholder="Descripción"
          value={form.descripcion}
          onChange={(e) =>
            setForm({
              ...form,
              descripcion:
                e.target.value
            })
          }
        />

        <select
          value={
            form.grupoSeleccionado
          }
          onChange={(e) =>
            setForm({
              ...form,
              grupoSeleccionado:
                e.target.value
            })
          }
        >

          <option value="GENERAL">
            TODOS LOS 11
          </option>

          {
            grados.map((g, index) => (

              <option
                key={index}
                value={JSON.stringify({
                  grado: g.grado,
                  grupo: g.grupo,
                  sede_id: g.sede_id
                })}
              >
                {g.sede}
                {" - "}
                {g.grado}
                {" "}
                {g.grupo}
              </option>
            ))
          }

        </select>

        <input
          type="number"
          placeholder="Tiempo"
          value={
            form.tiempo_minutos
          }
          onChange={(e) =>
            setForm({
              ...form,
              tiempo_minutos:
                e.target.value
            })
          }
        />

        <button
          onClick={
            crearSimulacro
          }
        >
          {
            loading
              ? "Creando..."
              : "Crear simulacro"
          }
        </button>

      </div>

      {/* ================================================= */}
      {/* ASIGNAR */}
      {/* ================================================= */}

      <div className="card">

        <h3>
          👨‍🏫 Asignar profesor
        </h3>

        <select
          value={
            asignacion.profesor_id
          }
          onChange={(e) =>
            setAsignacion({
              ...asignacion,
              profesor_id:
                e.target.value
            })
          }
        >

          <option value="">
            Profesor
          </option>

          {
            profesores.map((p) => (

              <option
                key={p.id}
                value={p.id}
              >
                {p.nombre}
                {" "}
                {p.apellido}
              </option>
            ))
          }

        </select>

        <select
          value={
            asignacion.materia_simulacro_id
          }
          onChange={(e) =>
            setAsignacion({
              ...asignacion,
              materia_simulacro_id:
                e.target.value
            })
          }
        >

          <option value="">
            Materia
          </option>

          {
            materias.map((m) => (

              <option
                key={m.id}
                value={m.id}
              >
                {m.nombre}
              </option>
            ))
          }

        </select>

      </div>

      {/* ================================================= */}
      {/* LISTA */}
      {/* ================================================= */}

      {
        simulacros.map((s) => {

          const resumen =
            resumenes[s.id];

          const estadisticas =
            resumen?.estadisticas;

          const profes =
            resumen?.profesores || [];

          const analitica =
            analiticas[s.id];

          return (

            <div
              key={s.id}
              className="simulacro-card"
            >

              <h3>
                📘 {s.titulo}
              </h3>

              <p>
                {s.descripcion}
              </p>

              <div
                style={{
                  marginBottom: "10px"
                }}
              >

                {
                  s.estado ===
                  "publicado"
                    ? (
                      <span
                        style={{
                          color: "green",
                          fontWeight: "bold"
                        }}
                      >
                        🟢 PUBLICADO
                      </span>
                    )
                    : (
                      <span
                        style={{
                          color: "orange",
                          fontWeight: "bold"
                        }}
                      >
                        🟡 BORRADOR
                      </span>
                    )
                }

              </div>

              <div>

                {
                  s.grupo ===
                  "GENERAL"
                    ? (
                      <span>
                        🎯 TODOS LOS 11
                      </span>
                    )
                    : (
                      <span>
                        🎯
                        {" "}
                        {s.grado}
                        {" "}
                        {s.grupo}
                      </span>
                    )
                }

              </div>

              {/* ===================================== */}
              {/* ESTADISTICAS */}
              {/* ===================================== */}

              {
                estadisticas && (

                  <div
                    className="stats-box"
                  >

                    <div>
                      👨‍🏫 Profesores:
                      {" "}
                      {
                        estadisticas.total_profesores
                      }
                    </div>

                    <div>
                      ✅ Terminados:
                      {" "}
                      {
                        estadisticas.terminados
                      }
                    </div>

                    <div>
                      ⏳ Pendientes:
                      {" "}
                      {
                        estadisticas.pendientes
                      }
                    </div>

                    <div>
                      ❓ Preguntas:
                      {" "}
                      {
                        estadisticas.total_preguntas
                      }
                    </div>

                    <div>
                      📊 Completado:
                      {" "}
                      {
                        estadisticas.porcentaje_completado
                      }%
                    </div>

                  </div>
                )
              }

              {/* ===================================== */}
              {/* BOTONES */}
              {/* ===================================== */}

              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  marginTop: "15px"
                }}
              >

                <button
                  onClick={() =>
                    asignar(s.id)
                  }
                >
                  Asignar profesor
                </button>

                {
                  s.estado !==
                  "publicado" && (

                    <button
                      onClick={() =>
                        publicarSimulacro(
                          s.id
                        )
                      }
                      disabled={
                        publicandoId ===
                        s.id
                      }
                    >
                      {
                        publicandoId ===
                        s.id
                          ? "Publicando..."
                          : "🚀 Publicar"
                      }
                    </button>
                  )
                }

              </div>

              {/* ===================================== */}
              {/* PROFESORES */}
              {/* ===================================== */}

              <div
                className="profesores-box"
              >

                {
                  profes.map((p) => (

                    <div
                      key={p.id}
                      className="profesor-item"
                    >

                      <div>
                        👨‍🏫
                        {" "}
                        {p.nombre}
                        {" "}
                        {p.apellido}
                      </div>

                      <div>
                        📚
                        {" "}
                        {p.materia}
                      </div>

                      <div>
                        ❓
                        {" "}
                        {
                          p.total_preguntas
                        }
                        {" "}
                        preguntas
                      </div>

                      <div>

                        {
                          p.estado ===
                          "terminado"
                            ? (
                              <span
                                style={{
                                  color:
                                    "green",
                                  fontWeight:
                                    "bold"
                                }}
                              >
                                ✅ TERMINADO
                              </span>
                            )
                            : (
                              <span
                                style={{
                                  color:
                                    "orange",
                                  fontWeight:
                                    "bold"
                                }}
                              >
                                ⏳ PENDIENTE
                              </span>
                            )
                        }

                      </div>

                    </div>
                  ))
                }

              </div>

              {/* ===================================== */}
              {/* ANALITICA */}
              {/* ===================================== */}

              {
                analitica?.ok && (

                  <div
                    className="card"
                    style={{
                      marginTop: "20px"
                    }}
                  >

                    <h3>
                      📈 Analítica
                    </h3>

                    {/* NO PRESENTARON */}

                    <div
                      style={{
                        marginBottom: "20px"
                      }}
                    >

                      <h4>
                        🚫 No han presentado
                      </h4>

                      {
                        analitica
                          .no_presentaron
                          ?.length > 0
                          ? (
                            analitica
                              .no_presentaron
                              .map((e) => (

                                <div
                                  key={e.id}
                                >
                                  👤
                                  {" "}
                                  {e.nombre}
                                  {" "}
                                  {e.apellido}
                                  {" - "}
                                  {e.grado}
                                  {" "}
                                  {e.grupo}
                                </div>
                              ))
                          )
                          : (
                            <p>
                              ✅ Todos presentaron
                            </p>
                          )
                      }

                    </div>

                    {/* PROMEDIOS GRUPO */}

                    <div
                      style={{
                        marginBottom: "20px"
                      }}
                    >

                      <h4>
                        🏫 Promedios por grupo
                      </h4>

                      {
                        analitica
                          .promedios_grupo
                          ?.map((g, i) => (

                            <div
                              key={i}
                            >
                              📘
                              {" "}
                              {g.grado}
                              {" "}
                              {g.grupo}
                              {" → "}
                              <strong>
                                {g.promedio}%
                              </strong>
                            </div>
                          ))
                      }

                    </div>

                    {/* PROMEDIOS SEDE */}

                    <div
                      style={{
                        marginBottom: "20px"
                      }}
                    >

                      <h4>
                        🏢 Promedios por sede
                      </h4>

                      {
                        analitica
                          .promedios_sede
                          ?.map((sede, i) => (

                            <div
                              key={i}
                            >
                              🏢
                              {" "}
                              {
                                sede.sede
                              }
                              {" → "}
                              <strong>
                                {
                                  sede.promedio
                                }%
                              </strong>
                            </div>
                          ))
                      }

                    </div>

                    {/* MATERIAS DEBILES */}

                    <div
                      style={{
                        marginBottom: "20px"
                      }}
                    >

                      <h4>
                        📉 Materias más débiles
                      </h4>

                      {
                        analitica
                          .materias_debiles
                          ?.map((m, i) => (

                            <div
                              key={i}
                            >
                              📚
                              {" "}
                              {
                                m.materia
                              }
                              {" → "}
                              <strong>
                                {
                                  m.promedio
                                }%
                              </strong>
                            </div>
                          ))
                      }

                    </div>

                    {/* PREGUNTAS FALLADAS */}

                    <div>

                      <h4>
                        ❌ Preguntas más falladas
                      </h4>

                      {
                        analitica
                          .preguntas_falladas
                          ?.map((p, i) => (

                            <div
                              key={i}
                              style={{
                                marginBottom:
                                  "15px",
                                padding:
                                  "10px",
                                border:
                                  "1px solid #ddd",
                                borderRadius:
                                  "8px"
                              }}
                            >

                              <div>
                                ❓
                                {" "}
                                {
                                  p.enunciado
                                }
                              </div>

                              <div>
                                📉 Error:
                                {" "}
                                <strong>
                                  {
                                    p.porcentaje_error
                                  }%
                                </strong>
                              </div>

                            </div>
                          ))
                      }

                    </div>

                  </div>
                )
              }

            </div>
          );
        })
      }

    </div>
  );
}